import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-horizontal.png';

export default function PublicFooter() {
  return (
    <footer className="bg-navy-900 mt-24">
      <div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-1">
          <img src={logo} alt="Tactmark" className="h-10 mb-4" />
          <p className="text-gray-300 text-sm leading-relaxed">
            Football and soccer analysis software for coaching decisions. Technical development oversight for federations.
          </p>
        </div>
        <div>
          <p className="text-white text-sm font-semibold mb-3">Products</p>
          <div className="flex flex-col gap-2 text-sm text-gray-300">
            <Link to="/products/post-match" className="hover:text-white transition-colors">Tactmark Post-Match</Link>
            <Link to="/products/federation" className="hover:text-white transition-colors">Tactmark Federation</Link>
            <Link to="/how-it-works" className="hover:text-white transition-colors">How it works</Link>
            <Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link>
          </div>
        </div>
        <div>
          <p className="text-white text-sm font-semibold mb-3">Analysis</p>
          <div className="flex flex-col gap-2 text-sm text-gray-300">
            <Link to="/football-analysis-software" className="hover:text-white transition-colors">Football analysis software</Link>
            <Link to="/soccer-analysis-software" className="hover:text-white transition-colors">Soccer analysis software</Link>
            <Link to="/soccer-coaching-tools" className="hover:text-white transition-colors">Soccer coaching tools</Link>
            <Link to="/post-match-analysis-engine" className="hover:text-white transition-colors">Post-match analysis engine</Link>
          </div>
        </div>
        <div>
          <p className="text-white text-sm font-semibold mb-3">Insights</p>
          <div className="flex flex-col gap-2 text-sm text-gray-300">
            <Link to="/insights" className="hover:text-white transition-colors">All Insights</Link>
            <Link to="/insights?category=Daily+Tactical+Note" className="hover:text-white transition-colors">Daily Tactical Notes</Link>
          </div>
        </div>
        <div>
          <p className="text-white text-sm font-semibold mb-3">Company</p>
          <div className="flex flex-col gap-2 text-sm text-gray-300">
            <Link to="/about" className="hover:text-white transition-colors">About</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-gray-400 text-xs">© {new Date().getFullYear()} Tactmark. All rights reserved.</p>
        <p className="text-gray-400 text-xs mt-1">Headquartered in Coeur d'Alene, Idaho, USA</p>
        <a href="mailto:hello@tactmark.com" className="text-gray-400 text-xs hover:text-white transition-colors">hello@tactmark.com</a>
      </div>
    </footer>
  );
}
